import { useState, useEffect } from "react";
import api from "api/api";
import { Link, useNavigate } from "react-router-dom";

//Props Validations
import PropTypes from "prop-types";

//Material UI Components

// import mui icons
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

//import assets

//import component
import FiltersHeaderLabel from "../components/common/FiltersHeaderLabel";
import Header from "../components/common/Header";
import Loader from "../components/common/Loader";
import MainNavigation from "../components/common/MainNavigation";
import FilterAcrossProductsToggleComponent from "components/common/FilterAcrossProductsToggleComponent";
import WeightToggleComponent from "components/common/WeightToggleComponent";
import Reset from "components/common/Reset";
import TTestDialog from "../components/common/TTest/TTestDialog";
import BeautyAndWellbeingTTestDialog from "../components/common/TTest/BeautyAndWellbeingTTestDialog";
import AnalysisTable from "components/common/analysisModule/AnalysisTable";
import AnalysisChart from "components/common/analysisModule/chart/AnalysisChart";

//redux
// redux
import { useSelector, useDispatch } from "react-redux";
import {
    loadJustRightAnalysisResultState,
    loadIsJustRightAnalysisResultLoadingState,
    loadClaimsAnalysisResultState,
    loadIsClaimsAnalysisResultLoadingState,
    loadAgreementAnalysisResultState,
    loadIsAgreementAnalysisResultLoadingState,
    loadOverallAnalysisResultState,
    loadIsOverallAnalysisResultLoadingState,
    loadSecondaryAnalysisResultState,
    loadIsSecondaryAnalysisResultLoadingState,
    loadIsItmDataState,
    loadDefaultAgreementAnalysisResultState,
    loadDefaultOverallAnalysisResultState,
    loadDefaultSecondaryAnalysisResultState,
    loadDefaultClaimsAnalysisResultState,
    loadDefaultJustRightAnalysisResultState,
} from "store/features/analysisResultsSlice";
import { resetTTestStore } from "store/features/ttestSlice";

import { loadAgreementRemovedKpiListState } from "store/features/analysisKpiSlice";
import { showNotification } from "store/features/notificationSlice";

import GetAgreementResult from "../utils/apis/GetAgreementResult";
import GetOverallResult from "../utils/apis/GetOverallResult";
import GetSecondaryResult from "../utils/apis/GetSecondaryResult";
import GetClaimsResult from "../utils/apis/GetClaimsResult";
import GetJustRightResult from "../utils/apis/GetJustRightResult";
import OverallToggleComponent from "../components/common/OverallToggleComponent";
import PenaltyToggleComponent from "../components/common/PenaltyToggleComponent";
import ViewToggle from "../components/common/ViewToggle";
import FullScreenConatiner from "../components/layouts/FullScreenConatiner";
import InitialPopup from "../components/common/InitialPopup";



function JustRightAnalysis({ headerTitle = "" }) {
    //REDUX
    const dispatch = useDispatch();
    const selectedStudy = useSelector((state) => state.studyDataStore.selectedStudies);

    const productsSecondaryDataState = useSelector((state) => state.analysisResultsStore.justRightAnalysisResult);
    const isLoading = useSelector((state) => state.analysisResultsStore.isJustRightAnalysisResultLoading);
    const weightToggle = useSelector((state) => state.analysisResultsStore.weightToggle);

    const isConsumerFilterSelected = useSelector((state) => state.consumerFilterStore.filterSelectionStatus);

    const productsOrder = useSelector((state) => state.productsInfoStore.productsOrder);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;

    const [isTableShown, setIsTableShown] = useState(true);

    const [dataMappingData, setDataMappingData] = useState([]);

    const [isDataMappingDataLoading, setIsDataMappingDataLoading] = useState(false);

    const navigate = useNavigate();

    // t-test details
    const [tTestResult, setTTestResult] = useState([]);
    const [testLabel, setTestLabel] = useState("");

    const [isFisher, setIsFisher] = useState(false);
    const [legends, setLegends] = useState([]);

    // const [tTestPerformed, setTTestPerformed] = useState(false);
    // const [confidenceInterval, setConfidenceInterval] = useState("");
    // const [tTestType, setTTestType] = useState("");
    // const [tTestProducts, setTTestProducts] = useState("");
    // const [tTestCoreDataId, setTTestCoreDataId] = useState(0);

    const [btnDisabled, setBtnDisabled] = useState({
        overallKpi: true,
        agreementKpi: true,
        claims: true,
        correlation: true,
        fragranceDriver: true
    });

    const penaltyToggle = useSelector((state) => state.analysisResultsStore.penaltyToggle);

    const isOralCare = process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCleansing = process.env?.REACT_APP_SKIN_CLEANSING?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isBeautyAndWellbeing = isHairCare || isSkinCare;
    const jarOrJustRightVariableCategory = (isBeautyAndWellbeing || isUnileverFragranceHouse) ? "JAR" : "Just Right";
    const analysisTitle = (isBeautyAndWellbeing || isUnileverFragranceHouse)
        ? penaltyToggle ? "Penalty Analysis" : "JAR Analysis"
        : headerTitle;

    const [activeTab, setActiveTab] = useState("");
    
    const hideClaimsBtn = isHairCare && penaltyToggle;
    const btnArr = isUnileverFragranceHouse ? ["overallKpi", "agreementKpi", "correlation"] : ["overallKpi", "agreementKpi", "claims", ...(isHairCare ? ["fragranceDriver"] : []), "correlation"];
    const activeBtnArr = hideClaimsBtn ? btnArr.filter((b) => b !== "claims") : btnArr;

    const clearResult = () => {
        setTTestResult([]);
        setTestLabel("");
        dispatch(resetTTestStore());

        // setTTestPerformed(false);
        // setConfidenceInterval("");
        // setTTestType("");
        // setTTestProducts("");
        // setTTestCoreDataId(null);
    };

    // clear T Test
    useEffect(() => {
        clearResult();
    }, [weightToggle]);

    useEffect(() => {
        if (isOralCare || isSkinCleansing) {
            if (!isLoading) {
                if (!isConsumerFilterSelected) {
                    InitialPopup.general();
                }
            }
        }
    }, [isLoading, isOralCare, isConsumerFilterSelected, isSkinCleansing]);

    const clearTtest = (product, type) => {
        if (type === "consumerFilterAll") {
            clearResult();
        } else if (type === "consumerFilter") {
            const tTestPro = tTestResult?.[0]?.colors?.map((datum) => datum.productCode) || [];
            const cfPc = product?.split("_")?.join(" ") || "";
            if (tTestPro.indexOf(cfPc) !== -1) {
                clearResult();
            }
        }
    };
    const getJustRightResult = async ({ product = null, coreDataId = null, type = null, consumerFilter = null, pcs = [], selectedStudy = [], allAnalysisData = {}, fetchOnlyCurrent = false }) => {
        // clear t test
        clearTtest(product, type);

        dispatch(loadIsAgreementAnalysisResultLoadingState(true));
        dispatch(loadIsOverallAnalysisResultLoadingState(true));
        dispatch(loadIsSecondaryAnalysisResultLoadingState(true));
        dispatch(loadIsClaimsAnalysisResultLoadingState(true));
        dispatch(loadIsJustRightAnalysisResultLoadingState(true));

        const justRightResult = await GetJustRightResult(product, coreDataId, type, consumerFilter, pcs, selectedStudy, allAnalysisData?.justRightAnalysisResult || [], productsOrder, productCategoryId, jarOrJustRightVariableCategory);
        if (justRightResult) {
            await dispatch(loadJustRightAnalysisResultState([...justRightResult]));
            if (!type) {
                dispatch(loadDefaultJustRightAnalysisResultState([...justRightResult]));
            }
        }
        dispatch(loadIsJustRightAnalysisResultLoadingState(false));

        const agreementResult = await GetAgreementResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.agreementAnalysisResult || [], productsOrder, productCategoryId });
        if (agreementResult) {
            await dispatch(loadAgreementAnalysisResultState([...agreementResult]));
            if (!type) {
                dispatch(loadDefaultAgreementAnalysisResultState([...agreementResult]));
            }
        }

        const overallResult = await GetOverallResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.overallAnalysisResult || [], productsOrder, productCategoryId });
        if (overallResult) {
            overallResult.forEach((product) => {
                product.scores.forEach((ele) => {
                    if (ele.backendVariable.includes("ITM_") && ele.mean) {
                        dispatch(loadIsItmDataState(true));
                    }
                });
            });
            dispatch(loadOverallAnalysisResultState([...overallResult]));
            if (!type) {
                dispatch(loadDefaultOverallAnalysisResultState([...overallResult]));
            }
        }

        const claimsResult = await GetClaimsResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.claimsAnalysisResult || [], productsOrder, productCategoryId });
        if (claimsResult) {
            dispatch(loadClaimsAnalysisResultState([...claimsResult]));
            if (!type) {
                dispatch(loadDefaultClaimsAnalysisResultState([...claimsResult]));
            }
        }

        const secondaryResult = await GetSecondaryResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.secondaryAnalysisResult || [], productsOrder, productCategoryId });
        if (secondaryResult) {
            dispatch(loadSecondaryAnalysisResultState([...secondaryResult]));
            if (!type) {
                dispatch(loadDefaultSecondaryAnalysisResultState([...secondaryResult]));
            }
        }

        dispatch(loadIsAgreementAnalysisResultLoadingState(false));
        dispatch(loadIsOverallAnalysisResultLoadingState(false));
        dispatch(loadIsSecondaryAnalysisResultLoadingState(false));
        dispatch(loadIsClaimsAnalysisResultLoadingState(false));
        console.log("fetchOnlyCurrent", fetchOnlyCurrent);
    };

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    const compareArrays = (arr1, arr2) => {
        const arrSorted2 = arr2.slice().sort();
        const isArrEqual =
            arr1.length === arr2.length &&
            arr1
                .slice()
                .sort()
                .every((value, index) => {
                    return value === arrSorted2[index];
                });
        return isArrEqual;
    };
    useEffect(() => {
        let _selectedStudies = selectedStudy;
        let disabled = true;
        let _country = _selectedStudies[0]?.country__title;
        let _deodorantFormat = _selectedStudies[0]?.format_data;

        if (isOralCare) {
            disabled = false;
        } else {
            _selectedStudies.forEach((each) => {
                if (each.country__title === _country && compareArrays(each.format_data, _deodorantFormat)) {
                    disabled = false;
                } else {
                    disabled = true;
                }
            });
        }

        let disableBtn = !_selectedStudies.length > 0;
        let tempObj = {
            overallKpi: disableBtn,
            agreementKpi: disableBtn,
            claims: disableBtn,
            correlation: disabled,
            justRight: disableBtn,
        };
        setBtnDisabled(tempObj);
    }, [selectedStudy, isOralCare]);

    useEffect(() => {
        async function fetchDataMappingData() {
            try {
                let url = process.env.REACT_APP_SERVER_PATH + `/data-mappings/all/?archive=false&uniq=true&variable_category=${encodeURIComponent(jarOrJustRightVariableCategory)}`;

                if (productCategoryId) {
                    url += `&product_category=${productCategoryId}`;
                }
                setIsDataMappingDataLoading(true);
                await api
                    .get(url)
                    .then(async (res) => {
                        setDataMappingData(res.data);
                        setIsDataMappingDataLoading(false);
                    })
                    .catch((error) => {
                        handleError("error", error);
                        setIsDataMappingDataLoading(false);
                    });
            } catch (error) {
                handleError("error", error);
                setIsDataMappingDataLoading(false);
            }
        }
        async function fetchAnalysisResult() {
            if (!productsSecondaryDataState.length) {
                await getJustRightResult({ product: null, coreDataId: null, type: null, consumerFilter: null, pcs: [], selectedStudy: selectedStudy, allAnalysisData: [], fetchOnlyCurrent: true });
            }
        }

        if (selectedStudy.length === 0) {
            navigate("/studies");
        } else {
            fetchAnalysisResult();
            fetchDataMappingData();
        }
    }, [selectedStudy, productsSecondaryDataState, isOralCare, productCategoryId]);

    // Clear the removed KPI data from the Redux store on page change to reset the default view.
    // Remove the code below if you want to retain the removed variables.
    useEffect(() => {
        return () => {
            dispatch(loadAgreementRemovedKpiListState([]));
        };
    }, [dispatch]);

    // const onTTestDataReceived = (tTest, tTestConfidenceInterval, testType, testProducts, tTestCoreDataId) => {
    //     setTTestPerformed(tTest);
    //     setConfidenceInterval(tTestConfidenceInterval);
    //     setTTestType(testType);
    //     setTTestProducts(testProducts);
    //     setTTestCoreDataId(tTestCoreDataId);
    // };

    return (
        <>
            {(isLoading || isDataMappingDataLoading) && <Loader />}
            <Header
                title={analysisTitle}
                isStudySelected={true}
            // tTestPerformed={tTestPerformed}
            // confidenceInterval={confidenceInterval}
            // tTestType={tTestType}
            // tTestProducts={tTestProducts}
            // tTestCoreDataId={tTestCoreDataId}
            />
            <div
                className="ms-4 me-4 mb-0 mt-3 background-color-white box-shadow--2 d-flex"
                style={{
                    borderRadius: "5px",
                }}
            >
                <FiltersHeaderLabel multipleLabel={true} />
            </div>
            <FullScreenConatiner>
                <div
                    className=""
                    style={{
                        width: 150,
                        display: "flex",
                        alignItems: "center",
                        position: "absolute",
                        zIndex: 1,
                    }}
                >
                    <Link
                        to="/studies"
                        onClick={(e) => {
                            if (window.history.length > 2) {
                                e.preventDefault();
                                navigate(-1);
                            }
                        }}
                    >
                        <div
                            className="p-2 liner-light-blue-background color-white"
                            style={{
                                borderRadius: "50%",
                                position: "relative",
                                top: -15,
                                left: -15,
                                cursor: "pointer",
                            }}
                        >
                            <span>
                                <ArrowBackIcon className="color-white" />
                            </span>
                        </div>
                    </Link>
                </div>

                <div
                    className="card-btns"
                    style={{ padding: "20px 20px 20px 20px" }}
                >
                    <div
                        style={{
                            display: "flex",
                            zIndex: 9,
                        }}
                    >
                        <div
                            style={{
                                marginBottom: "5px",
                                marginRight: "5px",
                            }}
                        >
                            <ViewToggle
                                value={isTableShown}
                                setValue={setIsTableShown}
                                labels={["Table", "Chart"]}
                            />
                        </div>
                    </div>

                    <div>
                        <PenaltyToggleComponent />
                        <OverallToggleComponent />
                        {!isUnileverFragranceHouse && (<WeightToggleComponent />)}
                        <FilterAcrossProductsToggleComponent />
                        {!isUnileverFragranceHouse && ((isBeautyAndWellbeing) ? (
                            <BeautyAndWellbeingTTestDialog
                                variableCategory={jarOrJustRightVariableCategory}
                                functionsSettings={{
                                    setIsFisher: setIsFisher,
                                    setLegends: setLegends,
                                    setTTestResult: setTTestResult,
                                    setTestLabel: setTestLabel,
                                    clearResult: clearResult,
                                    // onTTestDataReceived: onTTestDataReceived,
                                }}
                                analysisLevelData={{
                                    moduleName: "justRight",
                                    analysisTypeValue: {
                                        label: "Middle Box",
                                        value: "middle",
                                    },
                                    boxAnalysisTypeSelection: [],
                                    boxAnalysisSelection: {},
                                }}
                                tabData={{
                                    productsSecondaryDataState: productsSecondaryDataState,
                                }}
                            />
                        ) : (
                            <TTestDialog
                                variableCategory={jarOrJustRightVariableCategory}
                                functionsSettings={{
                                    setIsFisher: setIsFisher,
                                    setLegends: setLegends,
                                    setTTestResult: setTTestResult,
                                    setTestLabel: setTestLabel,
                                    clearResult: clearResult,
                                    // onTTestDataReceived: onTTestDataReceived,
                                }}
                                analysisLevelData={{
                                    moduleName: "justRight",
                                    analysisTypeValue: {
                                        label: "Middle Box",
                                        value: "middle",
                                    },
                                    boxAnalysisTypeSelection: [],
                                    boxAnalysisSelection: {},
                                    mappings: dataMappingData.columns,
                                }}
                                tabData={{
                                    productsSecondaryDataState: productsSecondaryDataState,
                                }}
                            />
                        ))}
                        <Reset clearTTestResult={clearResult} />
                    </div>
                </div>
                {productsSecondaryDataState.length !== 0 && dataMappingData.length !== 0 && (
                    <div
                        style={{
                            minHeight: "calc(100vh - 300px)",
                            padding: "20px",
                        }}
                    >
                        {isTableShown ? (
                            <>
                                <AnalysisTable
                                    productsSecondaryData={productsSecondaryDataState}
                                    handleFilterSubmit={getJustRightResult}
                                    selectedStudy={selectedStudy}
                                    analysisLevelData={{
                                        tableConfig: {
                                            stickyColumns: ["KPI"],
                                        },
                                        moduleName: "justRight",
                                        analysisTypeValue: (isBeautyAndWellbeing || isUnileverFragranceHouse)
                                            ? { label: "All Three Box", value: "allThreeBox" }
                                            : { label: "Middle Box", value: "middle" },
                                        boxAnalysisTypeSelection: [],
                                        mappings: dataMappingData.columns,
                                        penaltyToggle: penaltyToggle,
                                    }}
                                    tTest={{
                                        tTestLegends: legends,
                                        isFisher: isFisher,
                                        tTestResult: tTestResult,
                                        testLabel: testLabel,
                                    }}
                                    settings={{
                                        activeTab: activeTab,
                                        setActiveTab: setActiveTab,
                                    }}
                                />
                                {/* <ComparisonTable
                                    selectedStudy={selectedStudy}
                                    // productsRow={productsRow}
                                    productsSecondaryData={productsSecondaryDataState}
                                    dataMappingData={dataMappingData}
                                    activeMacroCategory={activeMacroCategory}
                                    column1={column1}
                                    column2={column2}
                                    tTestResult={tTestResult}
                                    // keyMapDisplayLabelConsumerFilter={keyMapDisplayLabelConsumerFilter}
                                    testLabel={testLabel}
                                    handleFilterSubmit={getJustRightResult}
                                /> */}
                            </>
                        ) : (
                            <AnalysisChart
                                productsSecondaryData={productsSecondaryDataState}
                                analysisLevelData={{
                                    moduleName: "justRight",
                                    analysisTypeValue: (isBeautyAndWellbeing || isUnileverFragranceHouse)
                                        ? { label: "All Three Box", value: "allThreeBox" }
                                        : { label: "Middle Box", value: "middle" },
                                    boxAnalysisTypeSelection: {},
                                    mappings: dataMappingData.columns,
                                    penaltyToggle: penaltyToggle,
                                }}
                                settings={{
                                    activeTab: activeTab,
                                    setActiveTab: setActiveTab,
                                }}
                                tTest={{
                                    tTestLegends: legends,
                                    isFisher: isFisher,
                                    tTestResult: tTestResult,
                                    testLabel: testLabel,
                                }}
                            />
                            // <AnalysisChart
                            //     selectedStudy={selectedStudy}
                            //     // productsRow={productsRow}
                            //     productsSecondaryData={productsSecondaryDataState}
                            //     dataMappingData={dataMappingData}
                            //     //activeMacroCategory={activeMacroCategory}
                            //     column1={[activeMacroCategory]}
                            //     column2={[activeMacroCategoryDisplayLabels]}
                            //     tTestResult={tTestResult}
                            //     chartType={chartType}
                            //     analysisType={"justRightAnalysis"}
                            //     colorsType={"justRightAnalysis"}
                            //     legends={legends}
                            //     componentName={"JustRightAnalysisDataState"}
                            //     pageName={"justRightAnalysis"}
                            //     dataView={dataView}
                            //     testLabel={testLabel}
                            //     removedList={removedList}
                            // />
                        )}

                        {/* Add spacing below the micro category
                        <div style={{ marginBottom: "50px" }}></div> */}
                    </div>
                )}
                <div
                    style={{
                        position: "relative",
                        // top: "-47px",
                        // float: "left",
                        // width: "100%",
                        // margin: "auto",
                        top: "5px",
                        marginTop: "30px",
                    }}
                >
                    <MainNavigation
                        buttons={activeBtnArr}
                        btnDisabledObj={btnDisabled}
                    />
                </div>
            </FullScreenConatiner>
        </>
    );
}

// Typechecking props for the JustRightAnalysis
JustRightAnalysis.propTypes = {
    headerTitle: PropTypes.string,
};

export default JustRightAnalysis;
